<template>
    <div class="layout-wrapper">
        <div class="container-fluid">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header  bg-accent-grad glow-accent text-center">
                        <h3 class="text-white">محاسبه سود قراردادها</h3>

                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="w-100 px-3">
                                <div class="card-header admin-header w-100">

                                    <h5 class="text-accent-light">سود قراردادها</h5>
                                    <!--<h5 class="text-accent-light" v-if="showReciveDate">(سر رسید تاریخ)</h5>-->
                                    <!--<div class="text-left">-->
                                    <!--<button class="btn btn-link text-accent-light text-left"-->
                                    <!--@click="onPrintClicked()"><i class="fa fa-print"></i>-->
                                    <!--</button>-->
                                    <!--<button class="btn btn-link text-accent-light"-->
                                    <!--@click="onReciveDateClicked()">-->
                                    <!--<i class="fa fa-calendar-benefit-o" v-if="showReciveDate"-->
                                    <!--title="عدم نمایش سررسیدها"></i>-->
                                    <!--<i class="fa fa-calendar-times-o" v-else title="نمایش سررسیدها"></i>-->
                                    <!--</button>-->
                                    <!--</div>-->
                                    <!--<button class="btn btn-link text-accent-light"-->
                                    <!--@click="onAddbenefitClicked()"><i class="fa fa-plus"></i>-->
                                    <!--</button>-->
                                </div>
                                <div class="row" v-if="!showReciveDate">
                                    <div class="col-lg-8 ">
                                        <div class="input-group round mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">جستجو</span>
                                            </div>
                                            <input class="form-control" v-model="search" @input="searching()"
                                                   placeholder="حداقل 2 کاراکتر از توضیحات یا مبلغ چک را وارد کنید">
                                        </div>
                                    </div>
                                    <div class="col-lg-4 ">
                                        <div class="input-group round">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">فیلتر وضعیت</span>
                                            </div>
                                            <vs-select @onSearch="onDropDownFocused"
                                                       @onSearchBlurred="onDropDownBlurred"
                                                       ref="evidence"
                                                       :data="benefitStatus"
                                                       :mode="'create'"
                                                       :selected-val="filterStatus"
                                                       :header="{multiple: false, label: 'title'}"
                                                       aria-placeholder="فیلتر براساس وضعیت"
                                                       @onChange="onFilterChange"></vs-select>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="table-responsive p-3">
                        <div v-if="!isLoading">
                            <preloader/>
                        </div>
                        <div v-else id="printMe">
                            <div v-if="mybenefits.length===0">
                                <p class="text-center mt-3">هیچ چکی ثبت نشده است.</p>

                            </div>
                            <div v-else>
                                <table class="table table-hover table-striped mb-3">
                                    <thead>
                                    <tr>
                                        <th  class="text-nowrap">قرارداد</th>
                                        <th  class="text-nowrap">مبلغ</th>
                                        <th  class="text-nowrap">دریافتی ها</th>
                                        <th  class="text-nowrap">هزینه ها</th>
                                        <th  class="text-nowrap">مانده</th>
                                        <th  class="text-nowrap">پرداختی کل قرارداد</th>
                                        <th  class="text-nowrap">سود ناخالص</th>
                                        <th  class="text-nowrap">پرداختی از سود ناخالص</th>
                                        <th  class="text-nowrap">سود خالص</th>
                                        <th  class="text-nowrap">پرداختی از سود خالص</th>
                                        <th  class="text-nowrap">مانده نهایی</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="it in mybenefits">

                                        <td class="text-nowrap clickable" @click="onBuyClicekd(it.customerBuyId)">
                                            {{it.customerBuyName}}
                                        </td>
                                        <td class="text-nowrap">{{it.customerBuyPrice.toLocaleString()}}</td>
                                        <td class="text-nowrap">{{it.recPrice.toLocaleString()}}</td>
                                        <td class="text-nowrap">{{it.payPrice.toLocaleString()}}</td>
                                        <td class="text-nowrap">{{it.remain.toLocaleString()}}</td>
                                        <td class="text-nowrap">{{it.totalPrice.toLocaleString()}}</td>
                                        <td class="text-nowrap">{{it.grossprofit.toLocaleString()}}</td>
                                        <td class="text-nowrap">{{it.grossprofitPrice.toLocaleString()}}</td>
                                        <td class="text-nowrap">{{it.netprofit.toLocaleString()}}</td>
                                        <td class="text-nowrap">{{it.netprofitPrice.toLocaleString()}}</td>
                                        <td class="text-nowrap">{{it.subTotalPrice.toLocaleString()}}</td>
                                        <!--<td class="text-nowrap">{{it.bank}}</td>-->
                                        <!--<td class="text-nowrap">{{it.accountNumber}}</td>-->
                                        <!--<td class="text-nowrap">{{it.benefitNumber}}</td>-->
                                        <!--<td class="text-nowrap">{{it.payRec ? it.name:"-&#45;&#45;"}}</td>-->
                                        <!--<td class="text-nowrap">{{!it.payRec ? it.name:"-&#45;&#45;"}}</td>-->
                                        <!--<td >{{it.benefitDescription}}</td>-->
                                        <!--<td class="clickable text-nowrap" @click="editItem(it)">{{it.statusName}}</td>-->
                                        <!--<td class="text-center"><i class="fa fa-pencil-square-o px-3 clickable"-->
                                        <!--style="font-size: larger"-->
                                        <!--@click="editItem(it)"-->
                                        <!--title="ویرایش آیتم"></i>-->
                                        <!--| <i class="fa fa-trash-o px-3 clickable"-->
                                        <!--style="font-size: larger"-->
                                        <!--@click="deleteItem(it)"-->
                                        <!--title="حذف آیتم"></i>-->
                                        <!--</td>-->

                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--///////////////////////////////////////////////////////////////////////////////////////////////////-->
            <modal show="false" ref="insertModal">
                <div class="row p-3">
                    <div class="col-12 text-center">
                        <h1>تغییر وضعیت چک</h1>
                    </div>
                    <div class="row p-5">
                        <div class="col-12 mb-3">
                            <h5 class="text-center">
                                چک
                                {{!benefitModel.payRec ? " پرداختی به " + benefitModel.name :""}}
                                {{benefitModel.payRec ? " دریافتی از " + benefitModel.name :""}}
                                بانک
                                {{benefitModel.bank}}
                                شماره حساب
                                {{benefitModel.accountNumber}}
                                شماره چک
                                {{benefitModel.benefitNumber}}
                                به تاریخ
                                {{benefitModel.fDate}}

                            </h5>
                        </div>
                        <div class="col-lg-6 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">وضعیت جدید چک</span>
                                </div>
                                <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                           ref="evidence"
                                           :data="benefitStatus"
                                           :mode="'create'"
                                           :selected-val="selectedStatus"
                                           :header="{multiple: false, label: 'title'}"
                                           aria-placeholder="وضعیت چک"
                                           @onChange="onStatusChange"></vs-select>
                            </div>
                        </div>
                        <div class="col-lg-6 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تاریخ جدید چک</span>
                                </div>
                                <date-picker type="date" format="jYYYY/jMM/jDD" @input="onnewDatePicked"
                                             :auto-submit="true"
                                             ref="newDate" style="flex: 1">
                                    <slot>
                                        <input v-model="newbenefitDate"
                                               class="form-control date-input flex-grow-1" readonly="true"
                                               @click="togglenewDatePicker">
                                    </slot>
                                </date-picker>
                            </div>
                        </div>
                    </div>


                    <div class="col-lg-6 offset-lg-3 text-center">
                        <label class="btn btn-success btn-round clickable mt-3"
                               @click="updatebenefit">ثبت تغییر وضعیت</label>
                        <label class="btn btn-primary btn-round clickable mt-3 mx-3"
                               @click="cancelbenefit">انصراف</label>
                    </div>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import BaseService from "../../_framework/api/BaseService";
    import DatePicker from '../../_framework/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect";
    import Utils from "../../_framework/utils/Utils";
    import Moment from 'moment-jalali';
    import Constants from "../../_framework/Constants";
    import VueHtmlToPaper from 'vue-html-to-paper';
    import Vue from 'vue';

    export default {
        name: "benefit",
        components: {VsSelect, DatePicker},
        data() {
            return {

                isLoading: false,
                mybenefits: [],

                benefitMode: "",
                benefitModel: {
                    benefitId: 0,
                    name: "",
                    benefitDate: "",
                    fDate: "",
                    price: 0,
                    bank: "",
                    accountNumber: "",
                    benefitNumber: "",
                    payRec: false,
                    statusName: "",
                    status: {},

                },

                benefitStatus: [],
                newbenefitDate: "",
                newDate: "",
                search: "",
                selectedStatus: 0,
                filterStatus: {},
                showReciveDate: false,
            }
        },
        mounted() {
            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            Vue.use(VueHtmlToPaper, printoptions);

            // this.getMybenefits();
            // if (this.$route.params.param === 'true') {
            //     this.onReciveDateClicked();
            // } else {
            this.getMybenefits();
            // }

            // this.getEnbenefitStatus();
        },
        methods: {
            onPrintClicked() {
                this.$htmlToPaper('printMe');
            },
            onBuyClicekd(it) {
                console.log(it)
                this.$router.push(
                    {
                        name: 'benefitByCustomerBuy',
                        params: {id: it}
                    }
                );
            },
            // onReciveDateClicked() {
            //     console.log("caleee")
            //     if (this.showReciveDate === true) {
            //         this.showReciveDate = false;
            //         this.getMybenefits();
            //     } else {
            //         this.showReciveDate = true;
            //         new BaseService("benefit", "/GetReciveDatebenefit").getList().then(response => {
            //             this.mybenefits = response.data;
            //             // for (let it of this.mybenefits) {
            //             //     it.fDate = Moment(this.gregorianToJalali(it.benefitDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
            //             // }
            //             this.isLoading = true;
            //         }).catch(error => {
            //             Utils.handleErrorWithNotification(error.data, this.$noty);
            //         });
            //     }
            // },

            onAddbenefitClicked() {
                this.benefitModel = {
                    id: 0,
                    family: "",
                    name: "",
                    fullName: "",
                    mobile: "",
                    fatherName: "",
                    address: "",
                };
                this.benefitMode = "create";
                this.$refs.insertModal.showModal();
            },
            getMybenefits() {
                this.showReciveDate = false;
                new BaseService("benefit", "/Getbenefit").getList().then(response => {
                    this.mybenefits = response.data;
                    // for (let it of this.mybenefits) {
                    //     it.fDate = Moment(this.gregorianToJalali(it.benefitDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                    // }
                    this.isLoading = true;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            editItem(item) {
                if (item.status === 2) {
                    Utils.handleErrorWithNotification("چک های واگزار شده قابل تغییر وضعیت نیستند", this.$noty);
                } else {
                    this.getEnbenefitStatus();
                    this.benefitModel = item;
                    this.benefitMode = "edit";
                    this.newbenefitDate = this.benefitModel.fDate;
                    this.newDate = this.benefitModel.benefitDate;
                    this.$refs.insertModal.showModal();
                }
            },
            deleteItem(item) {
                if (confirm("آیا از حذف این آیتم اطمینان دارید؟")) {
                    new BaseService("benefit", "Deletebenefit").delete(item.id).then(response => {
                        this.$noty.warning("آیتم با موفقیت حذف شد");
                        this.getMybenefits();
                    }).catch(error => {
                        Utils.handleErrorWithNotification("این آیتم در جای دیگری استفاده شده است، ابتدا موارد وابسته را پاک کنید", this.$noty);
                    })
                }
            },

            updatebenefit() {
                if (this.selectedStatus.value === 2) {
                    Utils.handleErrorWithNotification("فقط در قسمت پرداختهای میتوانید چک دریافتی را به وضعیت واگزار شده تغییر دهید", this.$noty);
                } else {
                    const newStatus = {
                        id: this.benefitModel.benefitId,
                        status: this.selectedStatus.value,
                        newDate: this.newDate,
                    };
                    new BaseService("benefit", "/UpdatebenefitStatus").update(newStatus).then(response => {
                        this.$noty.success("چک با موفقیت ویرایش شد");
                        this.$refs.insertModal.hideModal();
                        this.getMybenefits();
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                        this.$refs.insertModal.hideModal();
                        this.getMybenefits();
                    });
                }

            },
            createbenefit() {

                new BaseService("benefit", "/Createbenefit").create(this.benefitModel).then(response => {
                    this.$noty.success("مالک با موفقیت ثبت شد");
                    this.$refs.insertModal.hideModal();
                    this.getMybenefits();
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                    this.getMybenefits();
                });

            },
            cancelbenefit() {
                this.$refs.insertModal.hideModal();
                this.getMybenefits();
            },

            searching() {
                if (this.search.length > 2) {
                    this.isLoading = false;
                    new BaseService("benefit", `/Searchbenefit/${this.search}`).getList().then(response => {
                        this.mybenefits = response.data;
                        this.isLoading = true;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                } else {
                    this.getMybenefits();
                }
            },
            changeStatuse() {

            },
            onStatusChange(val) {
                if (val) {
                    this.benefitModel.status = val.value;
                    this.selectedStatus = val;
                }
            },
            onFilterChange(val) {
                if (val && val.value) {
                    this.filterStatus = val;
                    new BaseService("benefit", '/SearchbenefitByStatus/' + this.filterStatus.value).getList().then(response => {
                        this.mybenefits = response.data;
                        for (let it of this.mybenefits) {
                            it.fDate = Moment(this.gregorianToJalali(it.benefitDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                        }
                        this.isLoading = true;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                } else {
                    this.getMybenefits();
                }
            },
            getEnbenefitStatus() {
                new BaseService("Enum", "/GetEnbenefitStatus").getList().then(response => {
                    this.benefitStatus = response.data;
                }).catch(error => {
                    console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            onnewDatePicked(val) {
                this.newbenefitDate = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.newDate = this.jalaliToGregorian(val);
                console.log(this.newbenefitDate);
                console.log(this.newDate);
            },
            togglenewDatePicker() {
                this.$refs.newDate.togglePicker();
            },


        }
    }
</script>

<style lang="scss" scoped>
    .profile-image {
        margin: 0 auto 1rem auto;
    }

    .profile-image img {
        max-width: 150px;
        border-radius: 1rem;
        box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.25);
    }
</style>